import { InjectionToken } from '@angular/core';
import { SseServiceInterface } from '@shared/services/sse-interceptor/sse.service.interface';

export const SSE_SERVICE_TOKEN = new InjectionToken<SseServiceInterface>('SSE_SERVICE_TOKEN');

export const HEADER_SKIP_SSE_REFRESH_TOKEN = 'X-Skip-Sse-Refresh-Token';
export const HEADER_SKIP_SSE_TOKEN = 'X-Skip-Sse-Token';
